import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "./shared/services/auth.service";
import { RouterOutlet } from "@angular/router";
import { CommonModule } from "@angular/common";
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { NavbarComponent } from "./shared/components/navbar/navbar.component";
import { StorageService } from "./shared/services/storage.service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, CommonModule, LoaderComponent, NavbarComponent],
  standalone: true,
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor(
    public authService: AuthService,
    private router: Router,
    private storage: StorageService
  ) {
    const configuration = JSON.parse(
      this.storage.getItem("company") || "{}"
    )?.configuration;
    this.authService.updateCSSVariables(
      configuration?.primaryColor,
      configuration?.secondaryColor
    );
  }

  logout() {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }
}
